import React, { useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { InputFormGroup } from '../Common/Input/FormFields';
import { ProviderCommunicationPreferencesEnum, PROVIDER_COMM_METHODS, CareManagerCommunicationPreferencesEnum, CARE_MANAGER_COMM_METHODS } from '../../models/enums/CommunicationPreferences';
import { Grid, Cell } from 'react-foundation';
import UserContext from '../../UserContext';
import { SaveEvent, CheckboxEvent, SelectEvent } from '../Common/AnalyticsEvents';


export const ProviderCommunicationPreferences: React.FC = () => {
    const user = useContext(UserContext);
    const { values, setFieldValue } = useFormikContext<any>();
    const selectedMethods = values.communicationMethods || [];

    // Clear preferredPhoneNumber if Text Message is not selected
    useEffect(() => {
        if (!selectedMethods.includes(ProviderCommunicationPreferencesEnum.TextMessage) && values.preferredPhoneNumber !== '') {
            setFieldValue('preferredPhoneNumber', '');
        }
    }, [selectedMethods, setFieldValue, values.preferredPhoneNumber]);


  const handleCheckboxChange = (method: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    let updated: string[];
    if (checked) {
      updated = [...selectedMethods, method];
    } else {
      updated = selectedMethods.filter((m:any) => m !== method);
    }
    setFieldValue('communicationMethods', updated);
    SaveEvent(CheckboxEvent(user, 'Communication Preferences', method, checked));
  };

  return (
    <Cell className="card communication-preferences-card">
        <Cell>
            <h6 className="margin-none color-black preferences-section-title">
                <span className="far fa-comment margin-none"></span>  <b>Communication Preferences</b>
            </h6>
            <p className="font-small color-black">
                Set your preferred communication methods and contact preferences
            </p>
        </Cell>
       <Cell>
        <label><b>Preferred Communication Methods (Select All That Apply)</b></label>
        <p className="font-small"><i>By checking “Text Message” below, I give my express written consent to receive recruitment text messages from CareSource about job postings for waiver providers. I understand that message and data rates may apply, message frequency varies. I may reply HELP for help, and I may opt-out at any time by selecting the Opt-out link in any message received, replying STOP to a message, or updating your preferences here. SMS opt-in information will not be shared with third parties for marketing/promotional purposes. I have read and accept the <a target="_blank" href="https://www.caresource.com/about-us/legal/terms-and-conditions">Terms & Conditions</a>.</i></p>
        <Grid className="flex-column communication-methods-grid">
          {PROVIDER_COMM_METHODS.map(method => 
             (
            <label className="custom-checkbox-label" key={method}>
              <input
                type="checkbox"
                name="communicationMethods"
                className="custom-checkbox-input"
                value={method}
                checked={selectedMethods.includes(method)}
                onChange={handleCheckboxChange(method)}
              />
               <span className="custom-checkbox"></span>
              {method}
            </label>
          ))}
        </Grid>
      </Cell>
      {selectedMethods.includes(ProviderCommunicationPreferencesEnum.TextMessage) && (
        <Cell className="border-top half-width">
          <Cell className="placeholder-input-icon">
            <span className="icon far fa-phone"></span>
            <InputFormGroup
                name="preferredPhoneNumber"
                type="text"
                placeholder="xxx-xxx-xxxx"
                title="Phone Number for Text Messages"
                onBlurCapture={() => {
                    if (values.preferredPhoneNumber)
                        SaveEvent(SelectEvent(user, 'Provider Communication Preferences', 'PhoneNumber_Entered'))
                }}
            />
            </Cell>
        </Cell>
      )}
    </Cell>
  );
};

export const CareManagerCommunicationPreferences: React.FC = () => {
    const user = useContext(UserContext);
    const { values, setFieldValue } = useFormikContext<any>();
    const selectedMethods = values.communicationMethods || [];

    // Clear preferredPhoneNumber if Text Message is not selected
    useEffect(() => {
        if (!selectedMethods.includes(CareManagerCommunicationPreferencesEnum.TextMessage) && values.preferredPhoneNumber !== '') {
            setFieldValue('preferredPhoneNumber', '');
        }
    }, [selectedMethods, setFieldValue, values.preferredPhoneNumber]);


  const handleCheckboxChange = (method: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    let updated: string[];
    if (checked) {
      updated = [...selectedMethods, method];
    } else {
      updated = selectedMethods.filter((m:any) => m !== method);
    }
    setFieldValue('communicationMethods', updated);
    SaveEvent(CheckboxEvent(user, 'Communication Preferences', method, checked));
  };

  return (
    <Cell>
        <Cell>
            <h6 className="margin-none color-black preferences-section-title">
                <span className="far fa-comment margin-none"></span>  <b>Communication Preferences</b>
            </h6>
            <p className="font-small color-black">
                Set your desired Communication methods, types, and frequency
            </p>
        </Cell>
       <Cell>
        <label><b>Preferred Communication Methods (Select All That Apply)</b></label>
        <p className="font-small"><i>By checking “Text Message” below, I give my express written consent to receive recruitment text messages from CareSource about job postings for waiver providers. I understand that message and data rates may apply, message frequency varies. I may reply HELP for help, and I may opt-out at any time by selecting the Opt-out link in any message received, replying STOP to a message, or updating your preferences here. SMS opt-in information will not be shared with third parties for marketing/promotional purposes.</i></p>
        <Grid className="flex-column">
          {CARE_MANAGER_COMM_METHODS.map(method => 
             (
              <label className="custom-checkbox-label" key={method}>
                <input
                  type="checkbox"
                  name="communicationMethods"
                  className="custom-checkbox-input"
                  value={method}
                  checked={selectedMethods.includes(method)}
                  onChange={handleCheckboxChange(method)}
                />
                <span className="custom-checkbox"></span>
                {method}
              </label>
            )
          )}
        </Grid>
      </Cell>
        <Cell className="border-top half-width">
          <Cell className="placeholder-input-icon">
            <span className="icon far fa-phone"></span>
            <InputFormGroup
                name="preferredPhoneNumber"
                type="text"
                placeholder="xxx-xxx-xxxx"
                title="Phone Number for Text Messages"
                onBlurCapture={() => {
                    if (values.preferredPhoneNumber)
                        SaveEvent(SelectEvent(user, 'CM Communication Preferences', 'PhoneNumber_Entered'))
                }}
            />
            </Cell>
        </Cell>
    </Cell>
  );
};